var _excluded = ["integer", "fraction", "currency", "suffix", "isSmall", "isVertical", "isSpread", "hasTextColor", "priceTypography", "currencyTypography", "suffixTypography"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import space from "../../../utils/space";
import TextAtm from "../../atoms/TextAtm";
var Container = styled.div.withConfig({
  componentId: "sc-12jhnzc-0"
})(function (_ref) {
  var $isVertical = _ref.$isVertical,
    $isSpread = _ref.$isSpread;
  return css(["", " ", ""], !$isVertical && css(["display:flex;align-items:baseline;"]), $isSpread && css(["justify-content:space-between;"]));
});
var Price = styled.div.withConfig({
  componentId: "sc-12jhnzc-1"
})(["display:flex;align-items:baseline;> *{&:last-child{margin-left:", ";}}"], space(0.5));
function RegularPriceMol(_ref2) {
  var integer = _ref2.integer,
    fraction = _ref2.fraction,
    currency = _ref2.currency,
    suffix = _ref2.suffix,
    isSmall = _ref2.isSmall,
    isVertical = _ref2.isVertical,
    isSpread = _ref2.isSpread,
    hasTextColor = _ref2.hasTextColor,
    priceTypography = _ref2.priceTypography,
    currencyTypography = _ref2.currencyTypography,
    suffixTypography = _ref2.suffixTypography,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var priceColor = hasTextColor ? undefined : "primary";
  var defaultPriceTypography = isSmall ? "big3" : "great";
  var defaultCurrencyTypography = isSmall ? "nano1" : "big3";
  return /*#__PURE__*/React.createElement(Container, _extends({
    $isVertical: !!isVertical,
    $isSpread: !!isSpread
  }, restProps), /*#__PURE__*/React.createElement(Price, null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: priceTypography || defaultPriceTypography,
    color: priceColor
  }, integer), /*#__PURE__*/React.createElement(TextAtm, {
    typography: priceTypography || "big3",
    color: priceColor
  }, fraction), /*#__PURE__*/React.createElement(TextAtm, {
    typography: currencyTypography || defaultCurrencyTypography,
    color: priceColor
  }, currency)), /*#__PURE__*/React.createElement(TextAtm, {
    typography: suffixTypography || "nano2",
    emphasis: suffixTypography ? undefined : "medium"
  }, !isVertical && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0"), suffix));
}
export default RegularPriceMol;